"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CategoryCodeREL = function CategoryCodeREL(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 16 16"
  }, props), _react.default.createElement("g", null, _react.default.createElement("title", null, "CategoryCodeREL"), _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M9.313,8.449a.958.958,0,0,0,1.031.178.744.744,0,0,0,.426-.316L11.9,6.544a.744.744,0,0,0-1.254-.8l-.531.832-1.406-1.3a.959.959,0,0,0-1.474.208L5.152,8.931A.961.961,0,0,0,5.4,10.2l1.818,1.363H5.486a.96.96,0,0,0,0,1.92H10.1a.96.96,0,0,0,.576-1.728L7.6,9.424l.975-1.616Z"
  }), _react.default.createElement("circle", {
    cx: "9.554",
    cy: "3.864",
    r: "1.342"
  }))));
};

var _default = CategoryCodeREL;
exports.default = _default;